<script>
import { mapGetters } from 'vuex';
import Base from './base.vue';
import { PBX_REGIONS, regions } from '@/plans/ZOOM_PHONE/helper/constants';

export default {
    name: 'ADD',
    extends: Base,
    computed: {
      ...mapGetters(['boughtPlans', 'basicConfig']),

      minCallingPlan() {
        return 1
      },
      pbxRegions() {
        return regions.filter((x) => {
          const hasBought = this.boughtSelfPlans.find(p => p.region === x.key);
          if (hasBought && this.isBulkLicenseAccount) return false;
          if (hasBought?.isFreeTrial) return false;

          if (x.key === PBX_REGIONS.JP) return false
          if (this.$config('hideZoomPhoneUKIRPlans')) {
            if (hasBought) return true;
            return x.key !== PBX_REGIONS.UK_AND_IRELAND;
          }

          return true;
        })
        .filter(x => this.eduPlusPlans.find(item => item.region === x.key));
      },
    }
}
</script>
